import {epos2Axios} from "@/interceptors/axios";

class CustomerColoursDataService {
    getAll() {
        return epos2Axios.get('/api/assembly/customer/labelsettings');
    }

    getAllCustomers() {
        return epos2Axios.get('/api/customers');
    }

    getCustomersLabelSettings(customer_id) {
        return epos2Axios.get('/api/assembly/customer/labelsettings/'+customer_id);
    }
    save(formData) {
       /* const interceptors = () => {
            epos2Axios.interceptors.request.use(config => {
                config.data = formData;
                config.headers.setContentType("multipart/form-data");
                return config;
            });
        };
        interceptors(); //call the interceptors function*/

        return epos2Axios.post(
            `/api/assembly/customer/labelsettings`,
            formData,
            {
                headers: { 'Content-Type': 'multipart/form-data' }
            }
            );
    }

    delete(customerId) {
        return epos2Axios.delete(`/api/assembly/customer/labelsettings/${customerId}`);
    }

    findByCustomer(query) {
        return epos2Axios.get(`/api/assembly/customers?query=${query}`);
    }
}

export default new CustomerColoursDataService();